import { TextField } from '@mui/material'
import React from 'react'

export const BecomeSellerFormStep4 = ({formik}:any) => {
  return (
    <div className="space-y-5">
    {/* Business Name Field */}

    {/* Seller Name Field */}
    <TextField
      fullWidth
      name="sellerName"
      label="Seller Name"
      value={formik.values.sellerName}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      error={
        formik.touched.sellerName && Boolean(formik.errors.sellerName)
      }
      helperText={
        formik.touched.sellerName && formik.errors.sellerName
      }
    />

    {/* Email Field */}
    <TextField
      fullWidth
      name="email"
      label="Email"
      value={formik.values.email}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      error={formik.touched.email && Boolean(formik.errors.email)}
      helperText={formik.touched.email && formik.errors.email}
    />

    {/* Password Field */}
    <TextField
      fullWidth
      name="password"
      label="Password"
      type="password"
      value={formik.values.password}
      onChange={formik.handleChange}
      onBlur={formik.handleBlur}
      error={formik.touched.password && Boolean(formik.errors.password)}
      helperText={formik.touched.password && formik.errors.password}
    />
  </div>
  )
}
